
export enum ElectronicDeliveryMethod {
  Email = 'Email',
  Printer = 'Printer',
}
